<template>
    <component :is="getIconForPublicMode(mode)"/>
</template>

<script>
import IconWalk from '@/components/icons/IconWalk.vue'
import IconTrain from '@/components/icons/IconTrain.vue'
import IconBus from '@/components/icons/IconBus.vue'
import IconTram from '@/components/icons/IconTram.vue'
import IconSubway from '@/components/icons/IconSubway.vue'
import IconShip from '@/components/icons/IconShip.vue'
import IconCableCar from '@/components/icons/IconCableCar.vue'
import IconTaxiBus from '@/components/icons/IconTaxiBus.vue'
import IconGeneralTransport from '@/components/icons/IconGeneralTransport.vue'
import IconCarTrain from '@/components/icons/IconCarTrain.vue'
import IconCar from '@/components/icons/IconCar.vue'
import IconBike from '@/components/icons/IconBike.vue'
import IconScooter from '@/components/icons/IconScooter.vue'

export default {
    props: {
        mode: {
            type: String,
            default: ''
        }
    },
    components: {
        IconTrain,
        IconBus,
        IconTram,
        IconSubway,
        IconShip,
        IconCableCar,
        IconTaxiBus,
        IconGeneralTransport,
        IconCarTrain,
        IconWalk,
        IconCar,
        IconBike,
        IconScooter
    },
    methods: {
        getIconForPublicMode(mode) {
            let icon = false;
            const icons = {
                'Walk': 'Walk',
                'Drive': 'Car',
                'Bike': 'Bike',
                'Scooter': 'Scooter',
                'TRAIN': 'Train',
                'UNDERGROUND_RAILWAY': 'Subway',
                'TRAM': 'Tram',
                'CITY_BUS': 'Bus',
                'REGIONAL_BUS': 'Bus',
                'EXPRESS_BUS': 'Bus',
                'Ship': 'Ship',
                'CABLE_COG_RAILWAY': 'CableCar',
                'CALL_PICKUP_TAXI_BUS': 'TaxiBus',
                'URBAN_RAILWAY': 'Train',
                'CITY_RAILWAY': 'Train',
                'CAR_TRAIN': 'CarTrain',
                'OTHER': 'GeneralTransport',
            }
            if(icons[mode]){
                icon = 'Icon' + icons[mode];
            }
            return icon;
        },
    }
}
</script>